import { UI_LinkListGrid } from 'ui/components/3-organisms/LinkListGrid/LinkListGrid';

export const LinkListGrid = ({ content }: Content.LinkListGrid) => {
	const linkList = (content?.items ?? []).map((item) => item?.content);
	return <UI_LinkListGrid linkList={linkList} />;
};
